import { render, staticRenderFns } from "./TopFundsView.vue?vue&type=template&id=2e0b4e84&scoped=true"
import script from "./TopFundsView.vue?vue&type=script&lang=js"
export * from "./TopFundsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e0b4e84",
  null
  
)

export default component.exports